module.exports = __webpack_public_path__ + "img/logo.27c600a0.svg";